import type React from "react";
import { Page as Component } from "~/components/specifics/vendors/settings/company_settings/construction_item_settings/Page";
import { useCompanySettings } from "~/hooks/vendors/useCompanySettings";
import { useConstructionItemSettings } from "~/hooks/vendors/useConstructionItemSettings";
import { useConstructionItems } from "~/hooks/vendors/useConstructionItems";

type Props = {
	companyMasterId: number;
};

export const Page: React.FC<Props> = ({ companyMasterId }) => {
	const { data: companySetting } = useCompanySettings().show(companyMasterId);
	const { data: constructionItems } = useConstructionItems().index();
	const { data: constructionItemSettings } =
		useConstructionItemSettings(companyMasterId);

	if (
		constructionItems === null ||
		constructionItemSettings === null ||
		companySetting === null
	) {
		return null;
	}

	return (
		<Component
			companyMasterId={companyMasterId}
			companySetting={companySetting}
			constructionItemSettings={constructionItemSettings}
			constructionItems={constructionItems}
		/>
	);
};
